import React, { useEffect, useState, useRef } from 'react'
import classnames from 'classnames/bind'
import { random } from 'lodash-es'
import { useAppSelector, useAppDispatch } from '@/redux/hooks'

// Components
// import Image from '@/components/common/Image'

// Libs
import { setLikeListCursor } from '@/redux/reducers/room'
import { resetLikeList } from '@/redux/reducers/socket'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface IBalloon {
  emojiNo: number
  rotationAngle: number
}

const Balloon = () => {
  const dispatch = useAppDispatch()
  const roomData = useAppSelector((state: any) => state.room?.roomData)

  const timerIdRef = useRef<any>(null)
  const [balloonList, setBalloonList] = useState<IBalloon[]>([])
  const [timerIndex, setTimerIndex] = useState<number>(0)
  const [amount, setAmount] = useState<number>(0)
  const [isAnimationEnd, setIsAnimationEnd] = useState<boolean>(false)

  const socketData = useAppSelector((state: any) => state.socket)

  const { likeList } = socketData

  useEffect(() => {
    return () => {
      clearInterval(timerIdRef.current)
      dispatch(setLikeListCursor(null))
      dispatch(resetLikeList())
    }
  }, [])

  useEffect(() => {
    let timerId: any = null

    if (likeList.length > 0) {
      timerId = setInterval(() => {
        if (roomData.likeListCursor !== null) {
          // 第 2 筆之後的指針
          const lastCursorIndex = likeList.length - 1
          const currentCursorIndex = roomData.likeListCursor

          // 如果目前的指針還沒達到最後一筆，則移動指針去播放動畫
          // * 需等待前一輪動畫播完，才會移動指針
          if (currentCursorIndex < lastCursorIndex && isAnimationEnd) {
            const nextCursorIndex = roomData.likeListCursor + 1

            setIsAnimationEnd(false)
            setAmount(likeList[nextCursorIndex])
            dispatch(setLikeListCursor(nextCursorIndex))
          }
        } else {
          // 第 1 筆指針
          dispatch(setLikeListCursor(0))
          setAmount(likeList[0])
        }
      }, 1000)
    }

    return () => {
      clearInterval(timerId)
    }
  }, [likeList.length, roomData.likeListCursor, isAnimationEnd])

  useEffect(() => {
    if (amount > 0) {
      const payload: IBalloon[] = []
      const minNo = 0
      const maxNo = 11
      const minAngle = -50
      const maxAngle = 50
      let amountCount = 1

      timerIdRef.current = setInterval(() => {
        if (amountCount <= amount) {
          payload.push({ emojiNo: random(minNo, maxNo), rotationAngle: random(minAngle, maxAngle) })
        }

        amountCount = amountCount + 1
        setTimerIndex((prev) => prev + 1)
      }, 500)

      setBalloonList(payload)
    }
  }, [amount, roomData.likeListCursor])

  useEffect(() => {
    if (isAnimationEnd && timerIndex) {
      setBalloonList([])
    }
  }, [isAnimationEnd, timerIndex])

  const handleIsAnimationEnd = (itemIndex: any, amount: any) => {
    if (itemIndex >= amount) {
      setIsAnimationEnd(true)
    }

    return itemIndex >= amount
  }

  return (
    <>
      <div className={cx('balloon__area')}>
        {balloonList.map((balloon: IBalloon, index: number) => (
          <div
            key={`${balloon.emojiNo}-${index}`}
            onAnimationEnd={() => handleIsAnimationEnd(index + 1, amount)}
            className={cx('balloon__object')}
            style={{ transform: `rotate(${balloon.rotationAngle}deg)` }}
          >
            {/* FIXME: 用 <Image> emoji 起始位置會跑掉 */}
            <img src={`/images/svg/emoji_${balloon.emojiNo}.svg`} />
            {/* <Image src={`/images/svg/emoji_${balloon.emojiNo}.svg`} priority width={25} height={25} alt='emoji' /> */}
          </div>
        ))}
      </div>
    </>
  )
}

export default Balloon
